import setupConditionsUpdate from '../objects/set_up_conditions_update_function';

export const processConditionsEndOfTurn = (eventConditions, gameData, nbrMonths) => {

      let conditionsTable = gameData.conditionsTable;
      // decrement duration in the conditions table - go thru backwards so that splice doesn't mess up the index
      let maxIndx = conditionsTable.length - 1;
      for (let i=maxIndx; i>=0; i--){
            if (conditionsTable[i].duration){
                if (+conditionsTable[i].duration > 0){
                    conditionsTable[i].duration -= nbrMonths;
                    if (conditionsTable[i].duration < 0){
                        conditionsTable[i].duration = 0;                    
                    }
                }
                if (+conditionsTable[i].duration === 0){
                     conditionsTable.splice(i,1);
                }
            }
      }

      // add 'monthly' conditions if valid
      var conditionArr = [];
      var conditionFind = undefined;
      for (let i=0; i<eventConditions.length; i++){
          let condition = eventConditions[i];
          if (condition.triggeredBy === "monthly"){
               // check to determine if condition is already on the conditionTable
              conditionFind = conditionsTable.find(elem => elem.condName === condition.condName);
              if (!conditionFind){
                  conditionArr.push(condition);
              }
          }
      }
      let conditionClasses = [];
      let newConditionTable = setupConditionsUpdate(gameData, conditionArr, conditionClasses);
      for (let j=0; j<newConditionTable.length; j++){
          conditionsTable.push(newConditionTable[j]);
      }
               
    return conditionsTable;
}
export default processConditionsEndOfTurn;
